/**
 * Created by Miguel on 23/05/2017
 */
import { Component,OnInit, ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {Router} from "@angular/router";
import { CompanyService }  from '../../../services/company.service';
import { AppDataService }  from '../../../services/app-data.service';
declare var $ : any;

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'emojis-modal',
    templateUrl:'emojis-modal-component.html',
    providers  : [],
})
export class EmojiModalComponent implements OnInit {
    public emojis=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,23,24,25,26,27,28,29,30,31,32];
    public ngOnInit() : any {
    }
    constructor( public _sanitizer: DomSanitizer,public _router : Router,public _companyService : CompanyService,public _appData : AppDataService) {
    }
    public selectEmoji(emoji){
      this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({a:emoji})

      $('#emojisModal').modal('hide');
    }

}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/emojis-modal/emojis-modal-component.ts